import React, { FC } from "react";
import styles from "./styles.module.scss";
import { STAR_SIZE } from "./constants";
import Star from "../../../public/common/star.svg";

type Props = {
  stars: number;
  className?: string;
  starSize?: number;
};

const StarRating: FC<Props> = ({ stars, className, starSize = STAR_SIZE }) => (
  <div className={`${styles.container} ${className}`}>
    <div style={{ width: 5 * starSize }} className={styles.fullSizeWrapper}>
      <div style={{ width: stars * starSize }} className={styles.background}>
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.backgroundStar}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.backgroundStar}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.backgroundStar}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.backgroundStar}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.backgroundStar}
        />
      </div>
      <div style={{ width: stars * starSize }} className={styles.wrapper}>
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.star}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.star}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.star}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.star}
        />
        <Star
          style={{ minWidth: starSize, height: starSize }}
          className={styles.star}
        />
      </div>
    </div>
  </div>
);

StarRating.defaultProps = {
  starSize: STAR_SIZE,
  className: undefined
};

export default StarRating;
